import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { unregister } from './registerServiceWorker';
//import Routes from './Routes';
import Planner from './components/Planner';
//import 'semantic-ui-css/semantic.min.css';

ReactDOM.render(
<Planner />, document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/planner.js